import type {
  SchemaAdditionalExpenseType,
  SchemaCancellationExpenseType,
  SchemaMedicalExpenseType,
} from '@/types';

const medicalExpenseLabels: Record<SchemaMedicalExpenseType, string> = {
  medicalConsultation: 'Medical consultation',
  medicationOrMedicalEquipment: 'Medication or medical equipment',
  medicalTreatment: 'Medical treatment',
  dentalTreatment: 'Dental treatment',
};

const cancellationExpenseLabels: Record<SchemaCancellationExpenseType, string> = {
  accommodation: 'Accommodation cancellation',
  cruise: 'Cruise cancellation',
  flight: 'Flight cancellation',
  tour: 'Tour cancellation',
  transport: 'Transport cancellation',
  travelPackage: 'Travel package cancellation',
  other: 'Other cancellation',
};

const additionalExpenseLabels: Record<SchemaAdditionalExpenseType, string> = {
  accommodation: 'Accommodation additional expense',
  flight: 'Flight additional expense',
  transport: 'Transport additional expense',
  other: 'Other additional expense',
};

export { additionalExpenseLabels, cancellationExpenseLabels, medicalExpenseLabels };
